import React from "react";

import { Stack } from "@mui/material";

import Text from "@src/sharedComponents/Typography/Text";

import styles from "./TransitionProgressInfo.module.css";

interface TransitionProgressInfoProps {
  completedTasks?: number;
  totalTasks: number;
  showPercentage?: boolean;
}

const TransitionProgressInfo: React.FC<TransitionProgressInfoProps> = ({
  completedTasks,
  totalTasks,
  showPercentage = false,
}) => {
  const percentageValue =
    totalTasks > 0 && completedTasks !== undefined
      ? Math.round((completedTasks / totalTasks) * 100)
      : 0;

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      className={styles.progressStack}
    >
      {showPercentage && completedTasks !== undefined ? (
        <>
          <Text variant="title2" color="text">
            {percentageValue}% Complete
          </Text>
          <Text variant="body" color="text">
            ({completedTasks} of {totalTasks} tasks)
          </Text>
        </>
      ) : (
        <Text variant="body" color="textSubtle">
          {totalTasks} tasks
        </Text>
      )}
    </Stack>
  );
};

export default TransitionProgressInfo;
